import type { getDashboardExclusionList, getIspApiExclusionList } from './index'

type ExclusionListResponse = Awaited<ReturnType<typeof getIspApiExclusionList>> | Awaited<ReturnType<typeof getDashboardExclusionList>>

export const exclusionListResponse = ({ data, error }: ExclusionListResponse) => {
    if (error) {
        throw error
    }
    const { items = [], total } = data
    return {
        items: items.map(item => ({ ...item })),
        total: total === null ? 0 : total,
    }
}

export const ALLOWED = 'ALLOWED'
export const BLOCKED = 'BLOCKED'
